import React from 'react'

interface Props {
	children?: React.ReactNode
	title?: string
	completion?: Function
	[key: string]: any
	isMyFlex?: Boolean
}
const Modal = ({ children, title, completion }: Props) => {
	return (
		<div className="overlay">
			<div className="backdrop"></div>
			<div className="scroll-body">
				<div className="elevation">
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginBottom: '15px',
						}}
					>
						<h2 style={{ fontSize: '30px', fontWeight: 500 }}>{title}</h2>
						<span
							onClick={(e) => {
								completion?.()
							}}
							style={{
								fontFamily: 'Icons',
								fontSize: '2rem',
								cursor: 'pointer',
							}}
						>
							c
						</span>
					</div>

					{children}
				</div>
			</div>
		</div>
	)
}

export default Modal
